import React from "react";
import { useModal } from "../../store/modalStore";
import ConfirmModal from "./ConfirmModal";
import InfoModal from "./InfoModal";

/**
 * ModalRenderer
 * - 전역에서 모달을 한 번만 렌더링
 * - type에 따라 InfoModal / ConfirmModal 자동 전환
 */
const ModalRenderer: React.FC = () => {
  const {
    isOpen,
    type,
    title,
    message,
    confirmText,
    cancelText,
    variant,
    onConfirm,
    onCancel,
    close,
  } = useModal();

  if (!isOpen || !type) return null;

  if (type === "info") {
    return (
      <InfoModal
        title={title || "알림"}
        message={message || ""}
        onClose={onCancel || close}
      />
    );
  }

  if (type === "confirm") {
    return (
      <ConfirmModal
        isOpen={isOpen}
        title={title || "확인"}
        message={message || ""}
        confirmText={confirmText}
        cancelText={cancelText}
        variant={variant}
        onConfirm={() => {
          onConfirm?.();
          close();
        }}
        onCancel={() => {
          onCancel?.();
          close();
        }}
      />
    );
  }

  return null;
};

export default ModalRenderer;
